import React, { useEffect } from 'react'
import { DatePickerSeeker, disabledBeforeToday } from '@ui-seeker/core'
import { reportFormData, useManualExecution } from 'Pages/ReportsAlerts/Reports/@signals'
import { useReportFormInfo } from 'Pages/ReportsAlerts/Reports/@hooks'
import { object, string } from 'yup'
import { parseBackendDate } from '@utils'


export default function ReportDateMinExecution({ useDateRange }) {

	const {
		executionDateMin,
		setExecutionDateMinInfo,
		error,
	} = useReportFormInfo(parseBackendDate(reportFormData.peek().executionDateMin), 'executionDateMin', object({ executionDateMin: string().nullable() }))

	useEffect(() => {
		if (useManualExecution.value) setExecutionDateMinInfo(null)
	}, [useManualExecution.value])

	if (!useDateRange) return null

	return <DatePickerSeeker
		cleanable
		disabled={useManualExecution.value}
		label="Date Min Execution"
		shouldDisableDate={disabledBeforeToday()}
		value={executionDateMin}
		error={error}
		inputProps={{ sx: { backgroundColor: 'background.grey' } }}
		onChange={e => setExecutionDateMinInfo(e)}
	/>
}